import envConfigs from "../configs/envConfigs";
import { portalAuthHttpClient } from "../utils/HttpRequestUtils";

export const getShipmentsList = async (data) => {
  const url = `${envConfigs.csnUrl}${envConfigs.getShipmentsList}`;
  const response = await portalAuthHttpClient.post(url, data);
  return response;
};

export const getLiveTrackList = async (data) => {
  const url = `${envConfigs.csnUrl}${envConfigs.getLiveTrackList}`;
  const response = await portalAuthHttpClient.post(url, data);
  return response;
};

export const getAwbShipmemtDetails = async (awbNo, isPlanned) => {
  const configUrl = isPlanned
    ? envConfigs.getPlannedAwbShipmemtDetails
    : envConfigs.getActualAwbShipmemtDetails;
  const url = `${envConfigs.csnUrl}${configUrl}${awbNo}`;
  const response = await portalAuthHttpClient.get(url);
  return response;
};

export const getShipmentDetailsByCode = async (code) => {
  const url = `${envConfigs.baseUrl}${envConfigs.getShippingDetailsByCode}/${code}`;
  const response = await portalAuthHttpClient.get(url);
  return response;
};

export const getAwbLiveTrackingUrl = (shipmentID, isEnterpriseUser) =>
  `${envConfigs.liveTrackingBaseUrl}/cargo/customers/shipments/${shipmentID}?lt=${isEnterpriseUser ? 'eystaff' : 'consumer'}`;

export const getAwbsLiveTrackingUrl = (awbNumArray, isEnterpriseUser) =>
  `${envConfigs.liveTrackingBaseUrl}/cargo/customers/shipments?lt=${isEnterpriseUser ? 'eystaff' : 'consumer'}&mawbs=${awbNumArray.join(
    ","
  )}`;
